import { render, staticRenderFns } from "./EditSize.vue?vue&type=template&id=617280d6&"
import script from "./EditSize.vue?vue&type=script&lang=js&"
export * from "./EditSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports